import { Module } from 'vuex';

import { ShiftCMSState } from '@/store';
import { Category } from '@/models/category.model';

import categoriesService from '@/services/categories.service';

export interface CategoriesState {
  category: Category | null;
  categories: Category[];
}

export enum CategoriesMutations {
  SetCategory = 'cs/SetCategory',
  SetCategories = 'cs/SetCategories',
}

export enum CategoriesActions {
  GetCategory = 'cs/GetCategory',
  GetCategories = 'cs/GetCategories',
  AddCategory = 'cs/AddCategory',
  UpdateCategory = 'cs/UpdateCategory',
  UpdateCategoriesOrder = 'cs/UpdateCategoriesOrder',
  DeleteCategory = 'cs/DeleteCategory',
}

const sn = (str: CategoriesActions | CategoriesMutations): string =>
  str.replace(/cs\//g, '');

export const categoriesStore: Module<CategoriesState, ShiftCMSState> = {
  namespaced: true,
  state: {
    category: null,
    categories: [],
  },
  mutations: {
    [sn(CategoriesMutations.SetCategory)](state, category: Category | null) {
      state.category = category;
    },
    [sn(CategoriesMutations.SetCategories)](state, categories: Category[]) {
      state.categories = categories;
    },
  },
  actions: {
    async [sn(CategoriesActions.GetCategory)](_, id) {
      const res = await categoriesService.get(id);
      if (res.status) {
        return res.data;
      }
    },
    async [sn(CategoriesActions.GetCategories)]({ commit }) {
      const res = await categoriesService.getList();
      if (res.status) {
        commit(sn(CategoriesMutations.SetCategories), res.data);
      }
    },
    async [sn(CategoriesActions.AddCategory)](_, category: Category) {
      const res = await categoriesService.create({
        ...category,
        id: undefined,
      });

      return res.status;
    },
    async [sn(CategoriesActions.UpdateCategory)](_, category: Category) {
      const res = await categoriesService.edit(category);

      return res.status;
    },
    async [sn(CategoriesActions.UpdateCategoriesOrder)](
      { commit },
      order: number[],
    ) {
      const res = await categoriesService.updateOrder(order);

      if (res.status) {
        commit(sn(CategoriesMutations.SetCategories), res.data);
      }
    },
    async [sn(CategoriesActions.DeleteCategory)]({ dispatch }, id: number) {
      const res = await categoriesService.delete(id);

      if (res.status) {
        dispatch(sn(CategoriesActions.GetCategories));
      }
    },
  },
};
